import React from 'react';
import ErrorBoundary from '../../../shared-components/ErrorBoundary/ErrorBoundary';
import RemoveGWPDisqualifyPopup from './RemoveGWPDisqualifyPopup';
import RemoveGWPDowngradePopup from './RemoveGWPDowngradePopup';
import RemoveGWPOutOfStockPopup from './RemoveGWPOutOfStockPopup';
import RemoveGWPWarningPopup from './RemoveGWPWarningPopup';

const GwpPopupsContainer = () => (
  <>
    <ErrorBoundary>
      <RemoveGWPDisqualifyPopup />
    </ErrorBoundary>
    <ErrorBoundary>
      <RemoveGWPDowngradePopup />
    </ErrorBoundary>
    <ErrorBoundary>
      <RemoveGWPOutOfStockPopup />
    </ErrorBoundary>
    <ErrorBoundary>
      <RemoveGWPWarningPopup />
    </ErrorBoundary>
  </>
);

export default GwpPopupsContainer;
